<script setup lang="ts">
import { useContextElements } from "../context-elements.ts";
import type { ViewContext } from "../context.types.ts";
import { GuiElementTypes } from "../context.types.ts";
import QitBtn from "@/shared/components/buttons/qit-button.vue";

interface ContextButtonsProps extends ViewContext {
    flat?: boolean;
    border?: boolean;
    size?: string;
    compact?: boolean;
}

const props = withDefaults(defineProps<ContextButtonsProps>(), {
    flat: false,
    border: false,
    size: "md",
    compact: false,
});

const { elements, openUrl } = useContextElements(GuiElementTypes.buttons, props);
</script>

<template>
    <QitBtn
        v-for="element in elements"
        :size="size"
        padding="sm"
        class="btn-overflow-ellipsis"
        :class="{ border }"
        :data-qs="`context-button-${element.id}`"
        :key="element.id"
        :flat="flat"
        :disable="element.disabled"
        :color="flat ? 'none' : 'secondary'"
        :label="element.label"
        :icon="`fa-regular ui-extension-icon ${element.symbol} icon-color`"
        :compact="compact"
        @click.stop.prevent="openUrl(element.url, element.openInCurrentTab)"
    >
        <q-tooltip>{{ element.tooltip }}</q-tooltip>
    </QitBtn>
</template>

<style lang="scss" scoped>
.context-button {
    max-width: 350px;
    :deep(.q-btn__content) {
        > span {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }
    }
}
</style>
